import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, light = false }) => (
  <p className={`text-xs font-semibold uppercase tracking-[0.25em] ${light ? "text-lagoon" : "text-petrole"}`}>
    {children}
  </p>
);

export const scrollToHash = (hash) => (e) => {
  if (e) e.preventDefault();
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(hash, { offset: -125, duration: 1.4 });
  else document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" });
};

export const CONTACT = {
  phone: "078 638 02 03",
  phoneHref: "tel:+41786380203",
  email: "rossetconciergerie@gmail.com",
  address: "Route des Ecussons 10, 1950 Sion",
  site: "rossetconciergerie.ch",
};

export const IMG = {
  hero: "https://images.unsplash.com/photo-1777669164326-7a4f6e09e7cc?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  travaux: "/assets/gallery/porte-entree-apres-renovation.webp",
  pression: "/assets/gallery/toiture-vitree-karcher-haute-pression-valais.webp",
  valais: "https://images.unsplash.com/photo-1566424746223-f79e6597943b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
};

export const LogoMark = ({ className = "h-9 w-9" }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <circle cx="32" cy="32" r="28" stroke="#6EC1C8" strokeWidth="4" strokeDasharray="150 200" strokeLinecap="round" transform="rotate(-45 32 32)" />
    <path d="M22 44V28l10-9 10 9v16" stroke="#6EC1C8" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="29" y="33" width="6" height="6" fill="#6EC1C8" />
    <path d="M14 20l1.2 3 3 1.2-3 1.2L14 28.4l-1.2-3-3-1.2 3-1.2L14 20z" fill="#6EC1C8" />
  </svg>
);


export const track = (name, params = {}) => {
  if (window.gtag) window.gtag("event", name, params);
};
